export class RailProsError extends Error {
	errorNumber: number;
	message: string;
	friendlyMessage: string;
	constructor(
		errorNumber?: number,
		message?: string,
		friendlyMessage?: string
	) {
		super();
		this.errorNumber = errorNumber;
		this.message = message;
		this.friendlyMessage = friendlyMessage;
	}
}
